import { Box, Flex } from "@chakra-ui/react";
import { AnimatePresence } from "framer-motion";
import React, { Suspense, useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { SplashScreen } from "../components/Loader";
import NavBar from "../components/NavBar";
import { useAuth } from "../plugins/CookieAuthPlugin";

// Lazy Loading with Delay
const DelayImport = (path) => {
  return React.lazy(() => {
    return Promise.all([path, new Promise((resolve) => setTimeout(resolve, 300))]).then(([moduleExports]) => moduleExports);
  });
};

const MySLiquorPage = DelayImport(import("./homepage/index"));
const LoginPage = DelayImport(import("./auth/index"));

export default function App() {
  const { user } = useAuth();
  const location = useLocation();
  const [collapse, setCollapse] = useState(false);

  // Handle responsive design
  useEffect(() => {
    const handleResize = () => {
      setCollapse(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Suspense fallback={<SplashScreen />}>
      <Flex flexDir="column" position="relative" h="100vh" overflow="auto" id="app-container">
        {/* NavBar visible when the user is logged in */}
        {user?.statusLogin !== 1 && (
          <Box display="flex">
            <NavBar collapse={collapse} />
          </Box>
        )}

        <Box w={{ base: "full", sm: "95%", md: "85%", lg: "75%" }} h="calc(100vh - 60px)" px="2" flex="1" mx="auto" overflowY="auto">
          <AnimatePresence mode="wait">
            <Switch location={location} key={location.pathname}>
              {user && <Route path="/" component={MySLiquorPage} />}
              <Route path="/auth" component={LoginPage} />
              <Redirect to={user ? "/" : "/auth"} />
            </Switch>
          </AnimatePresence>
        </Box>
      </Flex>
    </Suspense>
  );
}
